import { CLOSE_CONTEXT_MENU, OPEN_CONTEXT_MENU, ADD_ITEMS_TO_CONTEXT_MENU_WIDGET, UPDATE_ITEMS_TO_CONTEXT_MENU, } from '../actions/ContextMenu';
const initialState = {
    buttonId: '',
    open: false,
    options: [],
    xOffset: 0,
    yOffset: 0,
    refinement: false,
    header: '',
    label: '',
    showSignInButton: false,
    hover: false,
};
const reducer = {
    [OPEN_CONTEXT_MENU]: (state, action) => {
        var _a;
        return (Object.assign(Object.assign(Object.assign({}, state), action.payload), { open: true, hover: ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.hover) === true }));
    },
    [CLOSE_CONTEXT_MENU]: (state, action) => (Object.assign(Object.assign({}, state), { open: false })),
    [ADD_ITEMS_TO_CONTEXT_MENU_WIDGET]: (state, action) => {
        const { widget } = state;
        if (!widget)
            return state;
        const newWidget = Object.assign(Object.assign({}, widget), { items: [...widget.items, ...action.payload.items], onEndOfWidget: action.payload.onEndOfWidget });
        return Object.assign(Object.assign({}, state), { widget: newWidget });
    },
    [UPDATE_ITEMS_TO_CONTEXT_MENU]: (state, action) => {
        var _a, _b, _c, _d;
        return (Object.assign(Object.assign({}, state), { widget: action.payload.widget, options: (_a = action.payload.settingsSection) === null || _a === void 0 ? void 0 : _a.items, contextMenuHeader: (_b = action.payload.settingsSection) === null || _b === void 0 ? void 0 : _b.contextMenuHeader, header: (_c = action.payload.settingsSection) === null || _c === void 0 ? void 0 : _c.header, label: (_d = action.payload.settingsSection) === null || _d === void 0 ? void 0 : _d.label }));
    },
};
export function ContextMenuReducer(state = initialState, action) {
    if (reducer[action.type]) {
        return reducer[action.type](state, action);
    }
    return state;
}
